import { FC, useEffect, useState } from 'react';
import { formatToBackDateTime } from '../../../../helpers/date-time';
import { pageKey } from '../../../../helpers/path';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { DateTime } from '../../../date-time/date-time';
import { TableFilter } from '../table-filter';

interface Props {
  name: string;
}

export const TableFilterDateTimeRange: FC<Props> = (props) => {
  const { name } = props;
  const { addQueryParams, getQueryParams } = useQueryParams();
  const [from, setFrom] = useState<Date>();
  const [to, setTo] = useState<Date>();

  useEffect(() => {
    const range = getQueryParams()[name];

    if (!range) {
      return;
    }
    const asObj = JSON.parse(range);
    const from = asObj.from ? new Date(asObj.from) : undefined;
    const to = asObj.to ? new Date(asObj.to) : undefined;
    setFrom(from);
    setTo(to);
  }, [name]);

  const handleOk = () => {
    if (from || to) {
      addQueryParams({ [name]: JSON.stringify({ from, to }), [pageKey]: '1' });
    }
  };

  const handleReset = () => {
    addQueryParams({ [name]: undefined, [pageKey]: '1' });
    setFrom(undefined);
    setTo(undefined);
  };

  return (
    <TableFilter onReset={handleReset} onSubmit={handleOk} name={name}>
      <DateTime onChange={setFrom} value={from ? formatToBackDateTime(from) : ''} />
      <DateTime onChange={setTo} value={to ? formatToBackDateTime(to) : ''} />
    </TableFilter>
  );
};
